/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useQueryState } from "./useQueryState";

export function useTabsWithUrl(param = "tab") {
  const { state, set } = useQueryState();

  const setActiveTab = (key: number) => {
    set(param)(key);
  };

  return {
    activeTab: Number(state[param] ?? 0),
    setActiveTab,
  };
}
